import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography } from '@mui/material';
// assets
import { PasswordIcon } from 'src/assets/icons';
// components
import Iconify from 'src/components/iconify';
import { Page } from 'src/components/Page';
// routes
import { PATH_AUTH } from 'src/routes/paths';

// sections
import ResetPasswordForm from './ResetPasswordForm';

// ----------------------------------------------------------------------

export default function ResetPassword() {
  return (
    <Page title="Reset Password">
      <PasswordIcon sx={{ mb: 5, height: 96 }} />
      <Typography variant="h3" paragraph>
        임시 비밀번호 발급
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 5 }}>
        임시비밀번호를 발급하여 이메일로 전송드립니다.
      </Typography>
      <ResetPasswordForm />
      <Link
        component={RouterLink}
        to={PATH_AUTH.login}
        color="inherit"
        variant="subtitle2"
        sx={{
          mt: 3,
          mx: 'auto',
          alignItems: 'center',
          display: 'inline-flex',
        }}
      >
        <Iconify icon="eva:chevron-left-fill" width={16} />
        로그인 페이지로 돌아가기
      </Link>
    </Page>
  );
}
